import { User } from "./user";

export class UserGroup {
  name: string;
  guid: string;
  members: User[];
  access: {
    allowComment: boolean,
    allowEdit: boolean
  }
  expanded: boolean;

  constructor(
    name: string = "",
    guid: string = "",
    members: User[] = [],
    allowComment: boolean = false,
    allowEdit: boolean = false,
    expanded: boolean = false
  ) {
    this.name = name;
    this.guid = guid;
    this.members = members;
    this.access = {
      allowComment: allowComment,
      allowEdit: allowEdit
    };
    this.expanded = expanded;
  }
}
